import moment from "moment";

export const dateToBrazilianDate = (date: string) =>
  date ? moment.utc(date).format("DD/MM/YYYY") : "";

export const dateToBrazilianHour = (date: string) =>
  date ? moment.utc(date).format("HH:mm") : "";

export const isOutdated = (date: string) => moment(date).isBefore(new Date());

export const getYearBeforeToday = (qtyYears: number) => {
  const years: string[] = [];
  for (let count = 0; count < qtyYears; count++) {
    years.push(moment().subtract(count, "years").format("YYYY"));
  }
  return years;
};

export const getYearAfterToday = (qtyYears: number) => {
  const years: string[] = [];
  for (let count = 0; count < qtyYears; count++) {
    years.push(moment().add(count, "years").format("YYYY"));
  }
  return years;
};
